/*eslint-disable*/
import { useCallback, useEffect, useState } from 'react';

// Local components
import SearchCriteria from './SearchCriteria.js';

// Redux
import { useSelector } from 'react-redux';
import { selectClientTenants } from 'features/client/clientSlice';
import {
  useLazyGetCashdrawersQuery,
  useLazyGetWorkstationsQuery,
} from 'api/location.api';
import { useGetTenantQuery } from 'api/tenant.api';

export default function Locations(props) {

  const clientTenants = useSelector(selectClientTenants);

  const { data: tenant } = useGetTenantQuery();
  const [triggerGetCashdrawers] = useLazyGetCashdrawersQuery();
  const [triggerGetWorkstations] = useLazyGetWorkstationsQuery();

  const getCurrentTenantStatus = (tenant_id) => {
    if (!tenant_id || !clientTenants) return null;
    let clientTenant = clientTenants.find((ct) => ct.tenant_id === tenant_id);
    return clientTenant ? clientTenant.status : null;
  };
  const [tenantStatus, setTenantStatus] = useState('');

  useEffect(() => {
    if (tenant) {
      let baseTenantStatus = getCurrentTenantStatus(tenant.tenant_id);
      setTenantStatus(baseTenantStatus);
    }
  }, [tenant, clientTenants]);

  const handleEditLocation = useCallback(async (location) => {
    await triggerGetCashdrawers(location.key).unwrap();
    await triggerGetWorkstations(location.key).unwrap();
    props.history.push('/admin/location', {
      location: location,
      new: false,
    });
  }, [triggerGetCashdrawers, triggerGetWorkstations, props.history]);

  const addLocationHandler = () => {
    props.history.push('/admin/location', { location: null, new: true });
  };

  return (
    <SearchCriteria
      editLocation={handleEditLocation}
      addLocation={addLocationHandler}
      tenantStatus={tenantStatus}
    />
  );
}
